module.exports = __webpack_public_path__ + "static/SL22-118af5da12b8e8f3d59fca3a05ee10f0.png";